import type { ResolvedTheme, ThemePreference } from '@typings/theme';

import type { SliceCreator } from '../types';

export interface ThemeSlice {
  /** What the visitor chose. `system` until they touch the toggle. */
  themePreference: ThemePreference;

  /** What is painted. Owned by ThemeManager, which writes it to <html>. */
  resolvedTheme: ResolvedTheme;

  setThemePreference: (preference: ThemePreference) => void;
  setResolvedTheme: (theme: ResolvedTheme) => void;
}

/**
 * Seeded from the attribute the inline script in index.html already set, so
 * the store agrees with the first painted frame instead of correcting it.
 */
const initialResolvedTheme = (): ResolvedTheme =>
  typeof document !== 'undefined' && document.documentElement.dataset.theme === 'light'
    ? 'light'
    : 'dark';

export const createThemeSlice: SliceCreator<ThemeSlice> = (set) => ({
  themePreference: 'system',
  resolvedTheme: initialResolvedTheme(),

  setThemePreference: (themePreference) => {
    set((state) => (state.themePreference === themePreference ? state : { themePreference }));
  },

  setResolvedTheme: (resolvedTheme) => {
    set((state) => (state.resolvedTheme === resolvedTheme ? state : { resolvedTheme }));
  },
});
